import styled, { css } from 'styled-components'
import { mediaQueries, colors } from 'theme'
import { isNotIE } from 'helpers'

const fontSize = '14px'
const backgroundGreen = colors.success
const disabledBackground = '#e0e0E0'
const disabledText = '#767676'
const hoverColor = '#357522'

export const Grid = styled.div`
  justify-content: flex-start;
  height: 100%;
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  @media ${mediaQueries.lessThanMedium} {
    margin: auto;
  }

  & > div {
    max-width: 275px;
    margin-right: 32px;
    white-space: nowrap;
    @media ${mediaQueries.lessThanSmall} {
      white-space: normal;
      margin-right: auto;
      margin-left: auto;
    }
  }
`

export const ParentRelationshipGrid = styled.div`
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  @media ${mediaQueries.lessThanMedium} {
    margin: auto;
    height: 100%;
  }
`

export const Form = styled.form`
  max-width: 1100px;
  display: flex;
  margin: auto;
  flex-direction: column;
  padding: 4vw;
`

export const CheckboxContainer = styled.div`
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  height: ${isNotIE ? '100%' : '100px'};
  width: fit-content;
  flex-wrap: wrap;
  @media ${mediaQueries.lessThanMedium} {
    margin: auto;
  }
`

export const GridHeading = styled.div`
  text-align: left;
  width: 100%;
  margin-bottom: 1vh;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
  min-width: 300px;
`

export const checkboxLabelStyles = css`
  min-width: 160px;
`

export const containerStyles = css`
  justify-content: flex-start;
`

export const relationshipCheckboxStyles = css`
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`

export const personalInfoContainerStyles = css`
  margin-right: 15px;
  justify-content: flex-start;
  width: fit-content;
  align-items: baseline;
`

const disabledStyles = `
  background-color: ${disabledBackground};
  color: ${disabledText};
  cursor: not-allowed;
`

const hoverStyles = `
  &:hover {
    background-color: ${hoverColor};
  }
`

export const QuestionText = styled.label`
  font-size: ${fontSize};
  margin-bottom: 8px;
`
/**
 * Copy of PrimaryButtom from syf-style-guide/ui/atoms/Buttons/Primary
 * to allow to set custom props
 */
export const PrimaryButton = styled.button`
  position: relative;
  width: 140px;
  height: 48px;
  border-style: solid;
  border-color: transparent;
  border-radius: 6px;
  font-size: ${fontSize};
  font-family: Open Sans;
  border-width: 2px;
  margin: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  cursor: pointer;
  overflow: hidden;
  font-weight: 800;
  background-color: ${backgroundGreen};
  border: none;
  ${({ disabled }) => {
    return disabled ? disabledStyles : hoverStyles
  }}
`

export const CheckboxContainerCenter = styled(CheckboxContainer)`
  max-height: 64px;
  width: fit-content;
  @media ${mediaQueries.lessThanMedium} {
    width: 100%;
    max-height: 148px;
    margin-bottom: 16px;
    justify-content: flex-start;
  }
`
